var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm.mode != "dice"
      ? _c(
          "span",
          {
            staticClass: "clicker",
            style:
              "cursor:" + (_vm.lastAction == "+" ? "n-resize" : "s-resize"),
            on: {
              click: function($event) {
                return _vm.add()
              },
              contextmenu: function($event) {
                return _vm.subtract($event)
              }
            }
          },
          [_vm._v(_vm._s(_vm.value))]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.mode == "dice"
      ? _c(
          "svg",
          {
            staticClass: "dice",
            style: "background-color:#" + _vm.color + ";",
            attrs: { height: "22", width: "22" },
            on: {
              click: function($event) {
                return _vm.add()
              },
              contextmenu: function($event) {
                return _vm.subtract($event)
              }
            }
          },
          [
            _c("circle", {
              style: _vm.getPipColor(0),
              attrs: { cx: "5", cy: "5", r: "2" }
            }),
            _vm._v(" "),
            _c("circle", {
              style: _vm.getPipColor(1),
              attrs: { cx: "5", cy: "10", r: "2" }
            }),
            _vm._v(" "),
            _c("circle", {
              style: _vm.getPipColor(2),
              attrs: { cx: "5", cy: "15", r: "2" }
            }),
            _vm._v(" "),
            _c("circle", {
              style: _vm.getPipColor(3),
              attrs: { cx: "10", cy: "10", r: "2" }
            }),
            _vm._v(" "),
            _c("circle", {
              style: _vm.getPipColor(4),
              attrs: { cx: "15", cy: "5", r: "2" }
            }),
            _vm._v(" "),
            _c("circle", {
              style: _vm.getPipColor(5),
              attrs: { cx: "15", cy: "10", r: "2" }
            }),
            _vm._v(" "),
            _c("circle", {
              style: _vm.getPipColor(6),
              attrs: { cx: "15", cy: "15", r: "2" }
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c9da26a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c9da26a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gemini/Clicker.vue
// module id = null
// module chunks = 